import { observable } from "mobx";
import { normalize } from "./utils";
import {
  HomeOutlined,
  SettingOutlined,
  TagsOutlined,
  UserOutlined,
  AlignLeftOutlined,
  MehOutlined,
  TeamOutlined,
  SolutionOutlined,
  NotificationOutlined,
  AccountBookOutlined,
  AppstoreOutlined,
  CloudServerOutlined,
  BranchesOutlined,
  RocketOutlined,
  CommentOutlined,
  ClusterOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";

export const gstate = observable({
  //当前访问路径
  pathname: normalize(window.location.pathname),
  loading: false,
  loadingTip: undefined,
  //用户
  user: null,
  perms: {},
  menus: null,
  defaultAvatar:
    "https://cos.chelun.com/static/20251111/a49163d8-8a4b-49fa-b02c-6e83f58cc145_200_200.png",
});

export function setUserInfo(users) {
  gstate.user = users;
  const perms = {};
  (users?.perms || []).forEach((p) => {
    perms[p] = true;
  });
  gstate.perms = perms;
}

export function initCommon() {
  gstate.menus = [
    {
      key: "home",
      label: "仪表盘",
      icon: <HomeOutlined />,
      path: "/home",
    },
    {
      key: "banner",
      label: "Banner管理",
      icon: <NotificationOutlined />,
      path: "/banner",
    },
    {
      key: "notice",
      label: "公告管理",
      icon: <NotificationOutlined />,
      path: "/notice",
    },
    {
      key: "user",
      label: "用户管理",
      icon: <UserOutlined />,
      path: "/user",
    },
    {
      key: "creatorAudit",
      label: "创作者管理",
      icon: <MehOutlined />,
      path: "/creatorAudit",
    },
    {
      key: "config",
      label: "配置数据",
      icon: <TagsOutlined />,
      path: "/config",
    },
    {
      key: "stat",
      label: "事件统计",
      icon: <AccountBookOutlined />,
      path: "/stat",
    },
    {
      key: "comment",
      label: "帖子评论",
      icon: <CommentOutlined />,
      path: "/comment",
    },
    {
      key: "post",
      label: "发布管理",
      icon: <AlignLeftOutlined />,
      path: "/post",
    },
    {
      key: "work",
      label: "作品管理",
      icon: <AppstoreOutlined />,
      path: "/work",
    },
    {
      key: "order",
      label: "订单管理",
      icon: <AccountBookOutlined />,
      path: "/order",
    },
    {
      key: "withdraw",
      label: "提现审核",
      icon: <AccountBookOutlined />,
      path: "/withdraw",
    },
    {
      key: "bbs",
      label: "匿名社区",
      icon: <CommentOutlined />,
      children: [
        {
          key: "bbs/board",
          label: "板块管理",
          path: "/bbs/board",
          icon: <ClusterOutlined />,
        },
        {
          key: "bbs/content",
          label: "内容管理",
          path: "/bbs/content",
          icon: <CommentOutlined />,
        },
        {
          key: "bbs/user",
          label: "封禁管理",
          path: "/bbs/user",
          icon: <SafetyCertificateOutlined />,
        },
      ],
    },
    {
      key: "appVersion",
      label: "版本管理",
      icon: <CloudServerOutlined />,
      children: [
        {
          key: "appVersion/channel",
          label: "渠道管理",
          path: "/appVersion/channel",
          icon: <BranchesOutlined />,
        },
        {
          key: "appVersion/version",
          label: "版本管理",
          path: "/appVersion/version",
          icon: <RocketOutlined />,
        },
      ],
    },
    {
      key: "admin",
      label: "系统管理",
      icon: <SettingOutlined />,
      children: [
        {
          key: "admin/role",
          label: "角色管理",
          path: "/admin/role",
          icon: <TeamOutlined />,
        },
        {
          key: "admin/account",
          label: "账号管理",
          path: "/admin/account",
          icon: <SolutionOutlined />,
        },
        {
          key: "admin/violation",
          label: "举报管理",
          path: "/admin/violation",
          icon: <SafetyCertificateOutlined />,
        },
      ],
    },
  ];
}
